import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

// Runtime feature flags (CK 3.0). One read of the feature_flags table per page
// load; the REACT_APP_* env vars are only the fallback default when the row is
// missing or the read fails. Flipping a row in the table turns a feature on or
// off everywhere — web AND the installed Capacitor app — without a rebuild,
// redeploy, or OTA push.
//
//   update feature_flags set enabled = false where key = 'empty_state_v2';
const ENV_DEFAULTS = {
  empty_state_v2: process.env.REACT_APP_EMPTY_STATE_V2 === 'true',
  sticky_track_bar: process.env.REACT_APP_STICKY_TRACK_BAR === 'true',
};

let flags = { ...ENV_DEFAULTS };
let fetchPromise = null;

function fetchFlags() {
  if (!fetchPromise) {
    fetchPromise = supabase
      .from('feature_flags')
      .select('key, enabled')
      .then(({ data, error }) => {
        if (error || !data) {
          if (error) console.warn('[featureFlags] read failed, using env defaults:', error.message);
          return flags;
        }
        data.forEach((row) => { flags[row.key] = !!row.enabled; });
        return flags;
      });
  }
  return fetchPromise;
}

// Returns the env default immediately, then the table value once the (cached,
// once-per-load) fetch resolves.
export function useFeatureFlag(key) {
  const [value, setValue] = useState(!!flags[key]);
  useEffect(() => {
    let mounted = true;
    fetchFlags().then((f) => { if (mounted) setValue(!!f[key]); });
    return () => { mounted = false; };
  }, [key]);
  return value;
}
